var initAllAccordions = function initAllAccordions() {
  var accordionTitles = document.querySelectorAll(".accordion-js-title");
  if (!accordionTitles) {
    return;
  }
  accordionTitles.forEach(function (accordionTitle) {
    accordionTitle.addEventListener("click", function () {
      if (accordionTitle.classList.contains("is-open")) {
        accordionTitle.classList.remove("is-open");
      } else {
        var accordionTitlesWithIsOpen = document.querySelectorAll(".is-open");
        accordionTitlesWithIsOpen.forEach(function (accordionTitleWithIsOpen) {
          accordionTitleWithIsOpen.classList.remove("is-open");
        });
        accordionTitle.classList.add("is-open");
      }
    });
  });
};
export { initAllAccordions };